import { debtsOtherObligations } from "./_debts_other_obligations";
import { debtsPermissionQuestion } from "./_debts_permission_question";
import { debtsSetSSN } from "./_debts_ssn";

export default {
  debtsOtherObligations,
  debtsPermissionQuestion,
  debtsSetSSN
}
